import { AxiosInstance } from 'axios';

import { useEffect } from 'react';
import { useState } from 'react';

import { Global } from '../ems-core/css/Global.styles';
import { listBesses } from '../ems-core/scripts/api';
import { Bess } from '../ems-core/scripts/api/types';
import { CountableList } from '../ems-core/scripts/types';
import { ViewBessSelect } from '../ems-core/views/BessSelect';
import LoadingPage from '../pages/LoadingPage';

type Props = {
  /**
   * Axios api instance
   */
  api: AxiosInstance;
  /**
   * Set the current active bess with the value provided
   */
  setBess: (bessId: string) => void;
  /**
   * Called if the user hits the 'Back' button
   */
  onGoBack: () => void;
  /**
   * Function to filter the besses, for example, only the ones that the user
   * has access to.
   */
  filterBess: (bess: Bess) => boolean;

  token: string;

  role?: number;
};

/**
 * Bess selection
 */
const Page = ({ api, setBess, filterBess, onGoBack, token, role }: Props) => {
  const [besses, setBesses] = useState<CountableList<Bess>>();
  const [isLoading, setLoading] = useState<boolean>(true);

  const getBesses = async () => {
    try {
      setLoading(true);
      const besses = await listBesses(api, 0, 50);
      setBesses(besses);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBesses();
  }, [api]);

  if (!isLoading && besses && besses.total > 0) {
    return (
      <>
        <Global />
        <ViewBessSelect
          data={besses}
          token={token}
          role={role}
          onGoBack={onGoBack}
          onSelect={(id: string) => setBess(id)}
          filterBess={filterBess}
        />
      </>
    );
  }
  return <LoadingPage />;
};
export default Page;
